import _ from 'lodash'
import qs from 'qs'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Button, Grid, Icon, Image, Input, Segment, TextArea } from 'semantic-ui-react'
import stringWidth from 'string-pixel-width'
import add from '../../assets/images/add.png'
import defaultAvatar from '../../assets/images/default-avatar.png'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { actions as participants } from '../../store/actions/participants'
import { actions as messages } from '../../store/actions/messages'
import ContactModal from '../contact-modal'

class ParticipantProfile extends Component {
    constructor (props) {
        super(props)
        this.state = {
            profile: {},
            value: '',
            field: undefined,
            index: -1,
            patientid: null,
            profilevisible: true,
            shouldShowContactModal: false
        }
        this.diagnosisReady = false
        autoBind(this)
    }

    componentDidMount() {
        if (this.props.userTokens.accessToken.token) {
            // Fetch the participant's profile.
            // this.fetchParticipant()
            this.setProfile()
        }
        document.addEventListener('mousedown', this.left)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token) {
            // Fetch the participant's profile.
            // this.fetchParticipant()
            this.setProfile()
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.left)
    }

    setProfile() {
        const data = this.props.participant_details[this.props.match.params.id]
        console.log("data: ", data)
        this.props.setParticipant({id: data.id, goal: data.goal, is_relief: data.is_relief})
        const profile = {
            id: data.id,
            picture: data.image_url,
            name: data.name,
            age: data.age,
            goal: {
                text: data.goal,
                beingEdited: false
            },
            diagnosis: data.diagnosis,
            demographics: data.demographics.map(s => {
                return {name: s, beingEdited: false}
            }),
            email: data.email,
            phone: data.phone,
            pid: data.participant_id,
            program_type: data.program_type,
            deployment: data.deployment,
            silvercloud_link: data.silvercloud_link,
            is_relief: data.is_relief
        }
        this.pointers = {}
        this.pointers['goal-1'] = React.createRef()
        this.pointers['goal-1_wrapper'] = React.createRef()
        profile.diagnosis.forEach((s, index) => {
            this.pointers[`diagnosis${index}`] = React.createRef()
            this.pointers[`diagnosis${index}_wrapper`] = React.createRef()
        })
        profile.demographics.forEach((s, index) => {
            this.pointers[`demographics${index}`] = React.createRef()
            this.pointers[`demographics${index}_wrapper`] = React.createRef()
        })
        this.setState({
            profile: profile,
            patientid: this.props.match.params.id
        })
        this.props.onParticipantProfileIsLoaded(data.silvercloud_link)
    }

    // Fetches the participant's profile.
    // fetchParticipant() {
    //     // eslint-disable-next-line no-console
    //     console.log(
    //         'patients= ' + this.state.patientid + ' ' + this.props.match.params.id
    //     )
    //     if (this.state.patientid !== this.props.match.params.id) {
    //         console.log('Fetch participant.')
    //         send({
    //             method: 'GET',
    //             tokens: this.props.userTokens,
    //             url: `/patients/${this.props.match.params.id}`
    //         })
    //             .then(response => {
    //                 // eslint-disable-next-line no-console
    //                 console.log('Fetched participant.')
    //                 const data = response.data
    //                 this.props.setParticipant({id: data.id, goal: data.goal, is_relief: data.is_relief})
    //                 const profile = {
    //                     id: data.id,
    //                     picture: data.image_url,
    //                     name: data.name,
    //                     age: data.age,
    //                     goal: {
    //                         text: data.goal,
    //                         beingEdited: false
    //                     },
    //                     diagnosis: data.diagnosis,
    //                     demographics: data.demographics.map(s => {
    //                         return {name: s, beingEdited: false}
    //                     }),
    //                     email: data.email,
    //                     phone: data.phone,
    //                     pid: data.participant_id,
    //                     program_type: data.program_type,
    //                     deployment: data.deployment,
    //                     silvercloud_link: data.silvercloud_link,
    //                     is_relief: data.is_relief
    //                 }
    //                 this.pointers = {}
    //                 this.pointers['goal-1'] = React.createRef()
    //                 this.pointers['goal-1_wrapper'] = React.createRef()
    //                 profile.diagnosis.forEach((s, index) => {
    //                     this.pointers[`diagnosis${index}`] = React.createRef()
    //                     this.pointers[`diagnosis${index}_wrapper`] = React.createRef()
    //                 })
    //                 profile.demographics.forEach((s, index) => {
    //                     this.pointers[`demographics${index}`] = React.createRef()
    //                     this.pointers[`demographics${index}_wrapper`] = React.createRef()
    //                 })
    //                 this.setState({
    //                     profile: profile,
    //                     patientid: this.props.match.params.id
    //                 })
    //                 this.props.onParticipantProfileIsLoaded(data.silvercloud_link)
    //             })
    //             .catch(error => {
    //                 // Failed to fetch participant. eslint-disable-next-line no-console
    //                 console.error(
    //                     `Failed to fetch participant ${this.props.match.params.id}.`,
    //                     error
    //                 )
    //                 this.props.onParticipantProfileIsLoaded(null)
    //                 // Hide the error.
    //             })
    //     }
    // }

    // Fetches all participants assigned to the therapist.
    // fetchParticipants(archived) {
    //     // eslint-disable-next-line no-console
    //     console.log('Fetch participants.')
    //     send({method: 'GET', tokens: this.props.userTokens, url: `/patients?archived=${archived ? 1 : 0}`})
    //         .then(response => {
    //             // eslint-disable-next-line no-console
    //             console.log('Fetched participants.')
    //             if (archived) {
    //                 this.props.setArchivedParticipants(response.data.patients)
    //             }
    //             else {
    //                 this.props.setActiveParticipants(response.data.patients)
    //             }
                
    //         })
    //         .catch(error => {
    //             // Failed to fetch participants. eslint-disable-next-line no-console
    //             console.error('Failed to fetch participants.', error)
    //             // Hide the error.
    //         })
    // }

    // Updates the participant.
    // updateParticipant() {
    //     // eslint-disable-next-line no-console
    //     console.log('Update participant.')
    //     const query = qs.stringify({
    //         diagnosis: this.state.profile.diagnosis[0],
    //         demographics: this.state.profile.demographics
    //             .map(s => {
    //                 return s.name
    //             })
    //             .join(','),
    //         goal: this.state.profile.goal.text
    //     })
    //     console.log('query= ' + query)
    //     send({
    //         method: 'PUT',
    //         tokens: this.props.userTokens,
    //         url: `/patients/${this.props.match.params.id}?${query}`
    //     })
    //         .then(_response => {
    //             // eslint-disable-next-line no-console
    //             console.log('Updated participant.')
    //             // Fetch the participant.
    //             this.fetchParticipant()
    //             // Fetch active participants.
    //             this.fetchParticipants(false)
    //             // Fetch archived participants.
    //             this.fetchParticipants(true)
    //         })
    //         .catch(error => {
    //             // Failed to update participant. eslint-disable-next-line no-console
    //             console.error('Failed to update participant.', error)
    //             // Hide the error.
    //         })
    // }

    updateParticipant() {
        const { profile } = this.state
        const participantId = this.props.match.params.id

        const query = qs.stringify({
            diagnosis: profile.diagnosis[0],
            demographics: profile.demographics.map(s => s.name).join(','),
            goal: profile.goal.text
        })

        send({
            method: 'PUT',
            tokens: this.props.userTokens,
            url: `/patients/${participantId}?${query}`
        })
            .then(() => {
                console.log('Participant updated successfully.')

                // 🔹 Update Redux with latest profile info (no re-fetch)
                const updatedProfile = {
                    id: profile.id,
                    goal: profile.goal.text,
                    is_relief: profile.is_relief,
                    diagnosis: profile.diagnosis,
                    demographics: profile.demographics.map(s => s.name),
                    age: profile.age,
                    name: profile.name,
                    picture: profile.picture,
                    email: profile.email,
                    phone: profile.phone,
                    participant_id: profile.pid,
                    program_type: profile.program_type,
                    deployment: profile.deployment,
                    silvercloud_link: profile.silvercloud_link
                }

                // Update current participant summary (for sidebar, etc.)
                this.props.setParticipant({
                    id: updatedProfile.id,
                    goal: updatedProfile.goal,
                    is_relief: updatedProfile.is_relief
                })

                // Update full participant details in Redux store
                this.props.setParticipantDetails({
                    participant_a0: participantId,
                    value: updatedProfile
                })

            })
            .catch(error => {
                console.error('Failed to update participant.', error)
                this.props.message({
                    type: 'error',
                    text: tr('FAILED_TO_SAVE_CHANGES')
                })
            })
    }

    left(e) {
        if (!this.state.field) {
            return
        }
        const ref = this.pointers[`${this.state.field}${this.state.index}_wrapper`]
        if (!ref || !ref.current.contains(e.target)) {
            // If the element that was being edited was the last one, and its value is empty, do not save it.
            if (
                this.state.index === this.state.profile[this.state.field].length - 1 &&
                _.isEmpty(this.state.value)
            ) {
                this.setState({
                    profile: {
                        ...this.state.profile,
                        [this.state.field]: (
                            this.state.profile[this.state.field] || []
                        ).filter((s, i) => {
                            return i !== this.state.index
                        })
                    },
                    value: '',
                    field: undefined,
                    index: -1
                })
            } else {
                this.saveValue(this.state.field, this.state.index)
            }
        }
    }

    // Changes the value that is being edited.
    changeValue(value) {
        this.setState({value})
    }

    // Starts or stops editing the value of the given field in the given index.
    toggleValueEditing(field, index, edit) {
        this.setState({
            profile: {
                ...this.state.profile,
                [field]:
                    field === 'goal'
                        ? {
                            ...this.state.profile.goal,
                            beingEdited: edit
                        }
                        : this.state.profile[field].map((s, i) => {
                            return i === index
                                ? {
                                    ...s,
                                    beingEdited: edit
                                }
                                : s
                        })
            },
            value: edit
                ? field === 'goal'
                    ? this.state.profile.goal.text
                    : this.state.profile[field][index].name
                : this.state.value,
            field: edit ? field : undefined,
            index: edit ? index : -1
        })
        // NOTE: Strange timeout needed to focus.
        setTimeout(() => {
            const ref = this.pointers[`${field}${index}`]
            if (ref && edit) {
                ref.current.focus()
                // ref.current.setSelectionRange(this.state.value.length, this.state.value.length);
            }
        }, 100)
    }

    selectedDiagnosis(value) {
        this.diagnosisReady = false
        this.setState(
            {
                profile: {
                    ...this.state.profile,
                    diagnosis: [value]
                }
            }, () => {
                this.diagnosisReady = true
            })

    }

    // Saves the value of the given field in the given index.
    saveValue(field, index) {
        this.setState(
            {
                profile: {
                    ...this.state.profile,
                    [field]:
                        field === 'goal'
                            ? {
                                text: this.state.value,
                                beingEdited: false
                            }
                            : this.state.profile[field].map((s, i) => {
                                return i === index
                                    ? {
                                        name: this.state.value,
                                        beingEdited: false
                                    }
                                    : s
                            })
                },
                value: '',
                field: undefined,
                index: -1
            },
            () => {
                this.updateParticipant()
            }
        )
    }

    saveDiagnosis() {
        const int = setInterval(() => {
            if (this.diagnosisReady) {
                this.updateParticipant()
                clearInterval(int)
                this.props.message({type: 'info', text: tr('YOUR_CHANGES_HAVE_BEEN_SAVED')})
            }
        }, 200)
    }

    // Deletes the value of the given field in the given index.
    deleteValue(field, index) {
        this.pointers[`${field}${this.state.profile[field].length}`] = undefined
        this.pointers[
            `${field}${this.state.profile[field].length}_wrapper`
            ] = undefined
        this.setState(
            {
                profile: {
                    ...this.state.profile,
                    [field]: this.state.profile[field].filter((s, i) => {
                        return i !== index
                    })
                },
                value: '',
                field: undefined,
                index: -1
            },
            () => {
                this.updateParticipant()
            }
        )
    }

    // Discards any changes to the value of the field in the given index.
    discardValue(field, index) {
        this.setState({
            profile: {
                ...this.state.profile,
                [field]:
                    field === 'goal'
                        ? {
                            ...this.state.profile.goal,
                            beingEdited: false
                        }
                        : this.state.profile[field].map((s, i) => {
                            return i === index
                                ? {
                                    ...s,
                                    beingEdited: false
                                }
                                : s
                        })
            },
            value: '',
            field: undefined,
            index: -1
        })
    }

    // Adds a new value to the given field.
    addValue(field) {
        this.pointers[
            `${field}${this.state.profile[field].length}`
            ] = React.createRef()
        this.pointers[
            `${field}${this.state.profile[field].length}_wrapper`
            ] = React.createRef()
        this.setState({
            profile: {
                ...this.state.profile,
                [field]: this.state.profile[field].concat({
                    name: '',
                    beingEdited: true
                })
            },
            value: '',
            field,
            index: this.state.profile[field].length
        })
    }

    closeContactModal() {
        this.setState({shouldShowContactModal: false})
    }

    toggle() {
        this.setState({
            profilevisible: !this.state.profilevisible
        })
    }

    render() {
        return (
            <Segment className="participant-profile">
                {this.state.shouldShowContactModal && (
                    <ContactModal phoneNumber={this.state.profile.phone} email={this.state.profile.email}
                                  onClose={this.closeContactModal}/>
                )}

                {!this.state.profilevisible && (
                    <Button className="notvisible" onClick={this.toggle}>
                        {this.state.profile.name}
                        {this.state.profile.age ? `, ${this.state.profile.age}` : ''}
                        <Icon
                            className="caret-arrow"
                            name={this.state.profilevisible ? 'angle right' : 'angle down'}
                            onClick={this.toggle}
                        />
                    </Button>
                )}

                {!this.state.profilevisible && this.state.profile.pid && (
                    <Segment className="pid pid-collapsed">
                        {tr('PARTICIPANT_ID') + `: ${this.state.profile.pid}`}
                    </Segment>
                )}
                {!this.state.profilevisible && this.state.profile.program_type && (
                    <Segment className="pid pid-collapsed">
                        {tr('PROGRAM_TYPE') + `: ${this.state.profile.program_type}`}
                    </Segment>
                )}
                {!this.state.profilevisible && this.state.profile.deployment && (
                    <Segment className="pid pid-collapsed">
                        {tr('DEPLOYMENT') + `: ${this.state.profile.deployment}`}
                    </Segment>
                )}
                {!this.state.profilevisible && this.state.profile.referred_from_pid && (
                    <Segment className="pid pid-collapsed">
                        {tr('REFERRAL') + `: ${this.state.profile.referred_from_pid}`}
                    </Segment>
                )}

                {!this.state.profilevisible && (
                    <Segment className="contactnotvis" onClick={() => this.setState({shouldShowContactModal: true})}>
                        {tr('CONTACT')}
                    </Segment>
                )}

                {this.state.profilevisible && (
                    <Grid columns={2}>
                        <Grid.Row>
                            <Grid.Column width={7}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column className="picture">
                                            <Image
                                                src={this.state.profile.picture || defaultAvatar}
                                                size="tiny"
                                                circular="circular"
                                            />
                                        </Grid.Column>
                                        <Grid.Column className="details">
                                            <Grid.Row>
                                                <Button className="name-age" onClick={this.toggle}>
                                                    {this.state.profile.name}
                                                    {this.state.profile.age >= 0
                                                        ? `, ${this.state.profile.age}`
                                                        : ''}
                                                    <Icon
                                                        className="caret-arrow"
                                                        name={
                                                            this.state.profilevisible
                                                                ? 'angle right'
                                                                : 'angle down'
                                                        }
                                                        onClick={this.toggle}
                                                    />
                                                </Button>
                                                {this.state.profile.pid && (
                                                    <Segment className="pid">
                                                        {tr('PARTICIPANT_ID') + `: ${this.state.profile.pid}`}
                                                    </Segment>
                                                )}
                                                {this.state.profile.program_type && (
                                                    <Segment className="pid">
                                                        {tr('PROGRAM_TYPE') + `: ${this.state.profile.program_type}`}
                                                    </Segment>
                                                )}
                                                {this.state.profile.deployment && (
                                                    <Segment className="pid">
                                                        {tr('DEPLOYMENT') + `: ${this.state.profile.deployment}`}
                                                    </Segment>
                                                )}
                                                {this.state.profile.referred_from_pid && (
                                                    <Segment className="pid">
                                                        {tr('REFERRAL') + `: ${this.state.profile.referred_from_pid}`}
                                                    </Segment>
                                                )}
                                                

                                            </Grid.Row>
                                            <Segment className="contact"
                                                     onClick={() => this.setState({shouldShowContactModal: true})}>
                                                {tr('CONTACT')}
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {/* <Grid.Row columns={1}>
                                        <Grid.Column className='diagnosis-section'>
                                            <Segment className='diagnosis-question'>
                                                {tr('ASSIGNED_PROGRAM') + ':'}
                                            </Segment>
                                            <Segment className='diagnosis-status'>
                                                <Dropdown
                                                    fluid
                                                    selection
                                                    icon='angle down'
                                                    placeholder={tr('SELECT_VALUE')}
                                                    options={
                                                        global.Diagnoses ? global.Diagnoses.map((diagnosis) => {
                                                            return {
                                                                value: diagnosis.value,
                                                                text: diagnosis.display.toUpperCase()
                                                            }
                                                        }) : ['']
                                                    }
                                                    value={this.state.profile.diagnosis ? this.state.profile.diagnosis[0] : ''}
                                                    onChange={(_e, {value}) => {
                                                        this.selectedDiagnosis(value)
                                                    }}
                                                />
                                                <Button className='save'
                                                        onClick={(_e) => {
                                                            this.saveDiagnosis()
                                                        }}>{tr('SAVE')}</Button>
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row> */}
                                </Grid>
                            </Grid.Column>
                            <Grid.Column width={9}>
                                <Grid>
                                    <Grid.Row columns={1}>
                                        <Grid.Column>
                                            <Segment className="demographics-title">
                                                {tr('DEMOGRAPHICS')}
                                            </Segment>
                                            <Segment className="demographics" clearing="clearing">
                                                {/* eslint-disable react/no-array-index-key */
                                                    this.state.profile.demographics &&
                                                    this.state.profile.demographics.map(
                                                        (demographic, index) => {
                                                            const value = demographic.beingEdited
                                                                ? this.state.value
                                                                : demographic.name
                                                            const width =
                                                                stringWidth(value, {
                                                                    size: 12,
                                                                    font: 'Arial'
                                                                }) + 64
                                                            return (
                                                                <Segment
                                                                    className="demographic"
                                                                    key={`demographic${index}`}
                                                                >
                                                                    <div
                                                                        ref={
                                                                            this.pointers[
                                                                                `demographics${index}_wrapper`
                                                                                ]
                                                                        }
                                                                    >
                                                                        <Input
                                                                            autoFocus="autoFocus"
                                                                            maxLength={30}
                                                                            ref={
                                                                                this.pointers[`demographics${index}`]
                                                                            }
                                                                            disabled={!demographic.beingEdited}
                                                                            onChange={e => {
                                                                                this.changeValue(e.target.value)
                                                                            }}
                                                                            onKeyUp={e => {
                                                                                e.stopPropagation()
                                                                                if (e.key === 'Enter') {
                                                                                    if (!e.target.value) {
                                                                                        this.deleteValue(
                                                                                            'demographics',
                                                                                            index
                                                                                        )
                                                                                    } else {
                                                                                        this.saveValue(
                                                                                            'demographics',
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                } else if (
                                                                                    e.key === 'Esc' ||
                                                                                    e.key === 'Escape'
                                                                                ) {
                                                                                    this.discardValue(
                                                                                        'demographics',
                                                                                        index
                                                                                    )
                                                                                    if (!demographic.name) {
                                                                                        this.deleteValue(
                                                                                            'demographics',
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                }
                                                                            }}
                                                                            value={value}
                                                                            style={{
                                                                                width:
                                                                                    (demographic.beingEdited
                                                                                        ? 200
                                                                                        : width) + 'px'
                                                                            }}
                                                                        />
                                                                        <Icon
                                                                            className="edit-toggler"
                                                                            name={
                                                                                demographic.beingEdited
                                                                                    ? 'delete'
                                                                                    : 'pencil'
                                                                            }
                                                                            onClick={e => {
                                                                                e.stopPropagation()
                                                                                if (demographic.beingEdited) {
                                                                                    this.deleteValue(
                                                                                        'demographics',
                                                                                        index
                                                                                    )
                                                                                } else {
                                                                                    this.toggleValueEditing(
                                                                                        'demographics',
                                                                                        index,
                                                                                        true
                                                                                    )
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Segment>
                                                            )
                                                        }
                                                    )
                                                    /* eslint-enable react/no-array-index-key */
                                                }
                                                <Segment className="add-demographic">
                                                    <Image
                                                        src={add}
                                                        onClick={_e => {
                                                            this.addValue('demographics')
                                                        }}
                                                    />
                                                </Segment>
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row columns={1}>
                                        <Grid.Column>
                                            <Segment className="goal-title">
                                                {tr('SET_GOAL')}
                                                {this.state.profile.goal &&
                                                this.state.profile.goal.text && (
                                                    <Icon
                                                        name="pencil"
                                                        className="edit-toggler goal"
                                                        onClick={_e => {
                                                            this.toggleValueEditing('goal', -1, true)
                                                        }}
                                                    />
                                                )}
                                            </Segment>
                                            <Segment className="goal" clearing="clearing">
                                                {this.state.profile.goal && (
                                                    <div ref={this.pointers['goal-1_wrapper']}>
                                                        <TextArea
                                                            ref={this.pointers['goal-1']}
                                                            name="goal"
                                                            className={`${
                                                                this.state.profile.goal.beingEdited
                                                                    ? 'being-edited'
                                                                    : ''
                                                            } ${
                                                                _.isEmpty(this.state.profile.goal.text)
                                                                    ? ''
                                                                    : 'with-value'
                                                            }`}
                                                            rows={
                                                                _.isEmpty(this.state.profile.goal.text) ? 1 : 2
                                                            }
                                                            disabled={
                                                                !_.isEmpty(this.state.profile.goal.text) &&
                                                                !this.state.profile.goal.beingEdited
                                                            }
                                                            placeholder={tr('WRITE_DESIRED_GOAL')}
                                                            maxLength={300}
                                                            value={
                                                                this.state.profile.goal.beingEdited
                                                                    ? this.state.value
                                                                    : this.state.profile.goal.text
                                                            }
                                                            onChange={e => {
                                                                this.changeValue(
                                                                    e.target.value.replace('\n', '')
                                                                )
                                                            }}
                                                            onFocus={_e => {
                                                                this.toggleValueEditing('goal', -1, true)
                                                            }}
                                                            onKeyUp={e => {
                                                                if (e.key === 'Enter') {
                                                                    this.saveValue('goal', -1)
                                                                    e.target.blur()
                                                                } else if (
                                                                    e.key === 'Esc' ||
                                                                    e.key === 'Escape'
                                                                ) {
                                                                    this.discardValue('goal', -1)
                                                                    e.target.blur()
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </Segment>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                )}
            </Segment>
        )
    }
}

const mapStateToProps = state => {
    return {
        language: state.settings.language,
        userTokens: state.users.userTokens,
        participant_details: state.participants.participant_details
    }
}

const mapDispatchToProps = dispatch => {
    const _participants = bindActionCreators(participants, dispatch)
    const _messages = bindActionCreators(messages, dispatch)
    return {
        setParticipant: _participants.setParticipant,
        setParticipantDetails: _participants.setParticipantDetails,
        message: _messages.message
    }
}

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ParticipantProfile)
)


// WEBPACK FOOTER //
// ./src/components/participant-profile/index.js